import {
  allBetHome,
  exchangeBetHome,
  sportsbookBetHome,
  listBetHomeMinuscle,
  warningBetHome,
  warningBetHomeMessages,
  warningBetHomeIcons,
  newListBetHomesSorted,
  newListBetHome,
  betHomeNoLimit,
  betHomeGlobal,
  globalBettingHouses,
  normalBetHome,
  listBettingHousesUnregulated,
  normalBetHomeLower,
} from "../variables/VariablesFilterSurebet";
import { deMarkCloneBetHome } from "../functions/FunctionsFilter";
import React, { useEffect, useRef, useState, useContext } from "react";
import { Tooltip } from "react-tooltip";
import { Context } from "../../App";
import { deduplicateArray } from "../../global/GlobalFunctions";

const BetHome = (props) => {
  const {
    openPageIndexFilter,
    statusMode,
    betHome,
    saveFilterBetHome,
    saveFilterChanged,
    requiredBetHome,
    setRequiredBetHome,
  } = props;

  let quantityAllBetHome = allBetHome.length;

  const [betHomeFrontEnd, setBetHomeFrontEnd] = useState([]);
  const [requiredBetHomeFrontEnd, setRequiredBetHomeFrontEnd] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const inputSearchRef = useRef(null);
  const { accountFeatures } = useContext(Context);

  const normalizeSearch = (text = "") =>
    text
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  const matchesSearch = (name) => {
    if (!searchTerm) return true;
    return normalizeSearch(name).includes(normalizeSearch(searchTerm));
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const clearSearch = () => {
    setSearchTerm("");
    if (inputSearchRef.current) {
      inputSearchRef.current.focus();
    }
  };

  function EnabledDisablebBethome(event) {
    const { checked, name } = event.target;
    const lowerCaseName = name.toLowerCase();

    if (checked === false) {
      if (requiredBetHomeFrontEnd.includes(lowerCaseName) === true) {
        setBetHomeFrontEnd((betHomes) => {
          return deduplicateArray(
            betHomes.filter((item) => item !== lowerCaseName),
          );
        });

        setRequiredBetHomeFrontEnd((betHomes) => {
          return betHomes.filter((item) => item !== lowerCaseName);
        });
      } else {
        deMarkCloneBetHome(lowerCaseName, setBetHomeFrontEnd);
        setRequiredBetHomeFrontEnd((current) => {
          return current.concat(lowerCaseName);
        });
      }
    } else {
      deMarkCloneBetHome(lowerCaseName, setBetHomeFrontEnd);
      deMarkCloneBetHome(lowerCaseName, setRequiredBetHomeFrontEnd, true);

      setBetHomeFrontEnd((current) => {
        return deduplicateArray(
          current
            .filter((item) => item !== lowerCaseName)
            .concat(lowerCaseName),
        );
      });
    }
  }

  useEffect(() => {
    setBetHomeFrontEnd(deduplicateArray(betHome));
    setRequiredBetHomeFrontEnd(requiredBetHome);
    // eslint-disable-next-line
  }, []);

  const filteredNewListBetHomesSorted = newListBetHomesSorted.filter(
    (value) => {
      if (!searchTerm) return true;
      if (matchesSearch(value.name)) return true;
      if (value.hasClone) {
        return value.allClones.some((clone) => matchesSearch(clone));
      }
      return false;
    },
  );

  const filteredExchangeBetHome = exchangeBetHome.filter((value) =>
    matchesSearch(value),
  );

  const filteredSportsbookBetHome = sportsbookBetHome.filter((value) =>
    matchesSearch(value),
  );

  const hasAnyBetHomeResult =
    filteredNewListBetHomesSorted.length > 0 ||
    filteredExchangeBetHome.length > 0 ||
    filteredSportsbookBetHome.length > 0;

  function markAll(event) {
    const { checked } = event.target;
    if (checked === false) {
      setBetHomeFrontEnd([]);
      setRequiredBetHomeFrontEnd([]);
    } else {
      setBetHomeFrontEnd(deduplicateArray(listBetHomeMinuscle));
    }
  }

  let listBettingHouseToSkip = [];
  const globalBettingHousesSearch = filteredNewListBetHomesSorted.filter(
    (item) => {
      if (listBettingHouseToSkip.includes(item["name"])) {
        return false;
      } else if (item["name"] === "Stake") {
        item["allClones"] = [];
        listBettingHouseToSkip.push("Stake");
      }

      return globalBettingHouses.includes(item["name"]);
    },
  );
  const normalBettingHousesSearch = filteredNewListBetHomesSorted.filter(
    (item) => {
      //
      if (listBettingHouseToSkip.includes(item["name"])) {
        let xxx = listBettingHouseToSkip.filter(
          (item000) => item000 != item["name"],
        );
        listBettingHouseToSkip = xxx;
        return false;
      }

      return normalBetHome.includes(item["name"]);
    },
  );

  return (
    <>
      <div
        className={`boxHeader border-bottom p-1 py-3 d-flex justify-content-start align-items-center ${
          statusMode ? "bgDark borderColor textGray" : ""
        }`}
      >
        <div
          className="ms-3 me-2"
          style={{
            width: "min-content",
            color: "rgb(13,110,253)",
            cursor: "pointer",
          }}
          onClick={openPageIndexFilter}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35px"
            height="35px"
            fill="currentColor"
            className="bi bi-arrow-left-square-fill filter-svg-back-page"
            viewBox="0 0 16 16"
          >
            <path d="M16 14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12zm-4.5-6.5H5.707l2.147-2.146a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L5.707 8.5H11.5a.5.5 0 0 0 0-1z"></path>
          </svg>
        </div>
        <div
          className={`boxOptions ${
            statusMode ? "bgDark borderColor textGray" : ""
          }`}
        >
          <p className="p-0 m-0 fw-semibold text-center fs-5">
            Casas de Apostas
          </p>
        </div>
      </div>
      <div className="px-3 py-2">
        <label htmlFor="search-bet-home-mobile" className="visually-hidden">
          Pesquisar casa de apostas
        </label>
        <div className="filter-search-wrapper">
          <input
            ref={inputSearchRef}
            id="search-bet-home-mobile"
            type="text"
            className={`form-control form-control-sm ${
              statusMode ? "bgDark borderColor textGray" : ""
            }`}
            placeholder="Pesquisar casa de apostas..."
            value={searchTerm}
            onChange={handleSearchChange}
            autoComplete="off"
          />
          {searchTerm && (
            <button
              type="button"
              className={`filter-search-clear-btn ${
                statusMode ? "textGray" : "text-secondary"
              }`}
              aria-label="Limpar pesquisa"
              onClick={clearSearch}
            >
              ×
            </button>
          )}
        </div>
      </div>

      <div
        id="allCheckBox"
        className=" px-3 d-flex flex-column filter fs-6"
        style={{ height: "370px", overflow: "overlay" }}
      >
        {accountFeatures.current.includes("global") && (
          <>
            <p></p>
            {globalBettingHousesSearch.map((value, index) => {
              let nameBetHomeFilterLower = value["name"].toLocaleLowerCase();
              let isEnableWarning =
                nameBetHomeFilterLower in warningBetHome ? true : false;
              return (
                <>
                  <div
                    className={`form-check gap-2 d-flex ${
                      statusMode ? "textGray" : ""
                    } ${listBettingHousesUnregulated.includes(nameBetHomeFilterLower) ? "align-items-start" : "align-items-center"}`}
                    key={index}
                    style={{ minHeight: "auto" }}
                  >
                    <input
                      type="checkbox"
                      id={"casasDeApostas" + index}
                      className={`form-check-input ${
                        requiredBetHomeFrontEnd.includes(
                          value["name"].toLowerCase(),
                        ) === true
                          ? "cus"
                          : ""
                      }`}
                      name={value["name"].toLocaleLowerCase()}
                      checked={betHomeFrontEnd.includes(
                        value["name"].toLocaleLowerCase(),
                      )}
                      onChange={EnabledDisablebBethome}
                    />

                    {nameBetHomeFilterLower in warningBetHome ? (
                      <img
                        data-tooltip-content={
                          isEnableWarning
                            ? warningBetHomeMessages[
                                warningBetHome[nameBetHomeFilterLower]
                              ]
                            : undefined
                        }
                        data-tooltip-id={
                          isEnableWarning ? "tooltip-surebet" : undefined
                        }
                        className="style-icon-alert-filter"
                        src={
                          warningBetHomeIcons[
                            warningBetHome[nameBetHomeFilterLower]
                          ]
                        }
                      />
                    ) : (
                      ""
                    )}

                    <label
                      title=""
                      htmlFor={"casasDeApostas" + index}
                      className="form-check-label"
                      name={value["name"].toLowerCase()}
                    >
                      <span className="nameBetHomeLabelMobile">
                        {value["name"]}
                      </span>
                      <>
                        <span class="badge rounded-1 bg-info ms-1 style-height-fit-content">
                          Global
                        </span>
                      </>
                      {newListBetHome.includes(nameBetHomeFilterLower) ===
                      true ? (
                        <span
                          class="badge rounded-1 text-bg-warning ms-1 style-height-fit-content"
                          style={{ fontSize: "8px" }}
                        >
                          New
                        </span>
                      ) : (
                        ""
                      )}
                      {betHomeNoLimit.includes(nameBetHomeFilterLower) && (
                        <>
                          <span class="badge rounded-1 style-bg-dark-green ms-1 style-height-fit-content">
                            Não Limita
                          </span>
                        </>
                      )}

                      {listBettingHousesUnregulated.includes(
                        nameBetHomeFilterLower,
                      ) && (
                        <>
                          <span class="badge rounded-1 style-bg-dark-green ms-1 style-height-fit-content">
                            Não Regulamentada
                          </span>
                        </>
                      )}
                    </label>
                  </div>

                  {value["hasClone"] ? (
                    <>
                      {value["allClones"]
                        .filter((itemClone) => matchesSearch(itemClone))
                        .map((itemClone, indexClone) => {
                          let nameCloneBetHomeFilterLower =
                            itemClone.toLocaleLowerCase();
                          return (
                            <div
                              className={`ms-3 gap-2 form-check d-flex align-items-center ${
                                statusMode ? "textGray" : ""
                              }`}
                              key={indexClone}
                            >
                              <input
                                type="checkbox"
                                id={
                                  "casasDeApostasClone" +
                                  value["name"] +
                                  indexClone
                                }
                                className={`form-check-input ${
                                  requiredBetHomeFrontEnd.includes(
                                    nameCloneBetHomeFilterLower,
                                  ) === true
                                    ? "cus"
                                    : ""
                                }`}
                                name={nameCloneBetHomeFilterLower}
                                checked={betHomeFrontEnd.includes(
                                  nameCloneBetHomeFilterLower,
                                )}
                                onChange={EnabledDisablebBethome}
                              />

                              {nameCloneBetHomeFilterLower in warningBetHome ? (
                                <img
                                  data-tooltip-content={
                                    isEnableWarning
                                      ? warningBetHomeMessages[
                                          warningBetHome[
                                            nameCloneBetHomeFilterLower
                                          ]
                                        ]
                                      : undefined
                                  }
                                  data-tooltip-id={
                                    isEnableWarning
                                      ? "tooltip-surebet"
                                      : undefined
                                  }
                                  className="style-icon-alert-filter"
                                  src={
                                    warningBetHomeIcons[
                                      warningBetHome[
                                        nameCloneBetHomeFilterLower
                                      ]
                                    ]
                                  }
                                />
                              ) : (
                                ""
                              )}

                              <label
                                title=""
                                htmlFor={
                                  "casasDeApostasClone" +
                                  value["name"] +
                                  indexClone
                                }
                                className="form-check-label"
                                name={nameCloneBetHomeFilterLower}
                              >
                                <span className="nameBetHomeLabelMobile">
                                  {itemClone}
                                </span>

                                {newListBetHome.includes(
                                  nameCloneBetHomeFilterLower,
                                ) === true ? (
                                  <span
                                    class="badge rounded-1 text-bg-warning ms-1 style-height-fit-content"
                                    style={{ fontSize: "8px" }}
                                  >
                                    New
                                  </span>
                                ) : (
                                  ""
                                )}
                                {betHomeNoLimit.includes(
                                  nameCloneBetHomeFilterLower,
                                ) && (
                                  <>
                                    <span class="badge rounded-1 style-bg-dark-green ms-1 style-height-fit-content">
                                      Não Limita
                                    </span>
                                  </>
                                )}

                                <>
                                  <span class="badge rounded-1 bg-info ms-1 style-height-fit-content">
                                    Global
                                  </span>
                                </>

                                {listBettingHousesUnregulated.includes(
                                  nameCloneBetHomeFilterLower,
                                ) && (
                                  <>
                                    <span class="badge rounded-1 style-bg-dark-green ms-1 style-height-fit-content">
                                      Não Regulamentada
                                    </span>
                                  </>
                                )}
                              </label>
                            </div>
                          );
                        })}
                    </>
                  ) : (
                    ""
                  )}
                </>
              );
            })}

            {!hasAnyBetHomeResult && searchTerm && (
              <div className="text-center py-3 px-2">
                <span className={statusMode ? "textGray" : "text-secondary"}>
                  Nenhuma casa de apostas global encontrada.
                </span>
              </div>
            )}
            <hr />
          </>
        )}

        {normalBettingHousesSearch.map((value, index) => {
          let nameBetHomeFilterLower = value["name"].toLocaleLowerCase();
          let isEnableWarning =
            nameBetHomeFilterLower in warningBetHome ? true : false;
          return (
            <>
              <div
                className={`form-check gap-2 d-flex ${
                  statusMode ? "textGray" : ""
                } ${listBettingHousesUnregulated.includes(nameBetHomeFilterLower) ? "align-items-start" : "align-items-center"}`}
                key={index}
                style={{ minHeight: "auto" }}
              >
                <input
                  type="checkbox"
                  id={"casasDeApostas" + index}
                  className={`form-check-input ${
                    requiredBetHomeFrontEnd.includes(
                      value["name"].toLowerCase(),
                    ) === true
                      ? "cus"
                      : ""
                  }`}
                  name={value["name"].toLocaleLowerCase()}
                  checked={betHomeFrontEnd.includes(
                    value["name"].toLocaleLowerCase(),
                  )}
                  onChange={EnabledDisablebBethome}
                />

                {nameBetHomeFilterLower in warningBetHome ? (
                  <img
                    data-tooltip-content={
                      isEnableWarning
                        ? warningBetHomeMessages[
                            warningBetHome[nameBetHomeFilterLower]
                          ]
                        : undefined
                    }
                    data-tooltip-id={
                      isEnableWarning ? "tooltip-surebet" : undefined
                    }
                    className="style-icon-alert-filter"
                    src={
                      warningBetHomeIcons[
                        warningBetHome[nameBetHomeFilterLower]
                      ]
                    }
                  />
                ) : (
                  ""
                )}

                <label
                  title=""
                  htmlFor={"casasDeApostas" + index}
                  className="form-check-label"
                  name={value["name"].toLowerCase()}
                >
                  <span className="nameBetHomeLabelMobile">
                    {value["name"]}
                  </span>

                  {newListBetHome.includes(nameBetHomeFilterLower) === true ? (
                    <span
                      class="badge rounded-1 text-bg-warning ms-1 style-height-fit-content"
                      style={{ fontSize: "8px" }}
                    >
                      New
                    </span>
                  ) : (
                    ""
                  )}
                  {betHomeNoLimit.includes(nameBetHomeFilterLower) && (
                    <>
                      <span class="badge rounded-1 style-bg-dark-green ms-1 style-height-fit-content">
                        Não Limita
                      </span>
                    </>
                  )}

                  {listBettingHousesUnregulated.includes(
                    nameBetHomeFilterLower,
                  ) && (
                    <>
                      <span class="badge rounded-1 style-bg-dark-green ms-1 style-height-fit-content">
                        Não Regulamentada
                      </span>
                    </>
                  )}
                </label>
              </div>

              {value["hasClone"] ? (
                <>
                  {value["allClones"]
                    .filter((itemClone) => matchesSearch(itemClone))
                    .map((itemClone, indexClone) => {
                      let nameCloneBetHomeFilterLower =
                        itemClone.toLocaleLowerCase();
                      return (
                        <div
                          className={`ms-3 gap-2 form-check d-flex align-items-center ${
                            statusMode ? "textGray" : ""
                          }`}
                          key={indexClone}
                        >
                          <input
                            type="checkbox"
                            id={
                              "casasDeApostasClone" + value["name"] + indexClone
                            }
                            className={`form-check-input ${
                              requiredBetHomeFrontEnd.includes(
                                nameCloneBetHomeFilterLower,
                              ) === true
                                ? "cus"
                                : ""
                            }`}
                            name={nameCloneBetHomeFilterLower}
                            checked={betHomeFrontEnd.includes(
                              nameCloneBetHomeFilterLower,
                            )}
                            onChange={EnabledDisablebBethome}
                          />

                          {nameCloneBetHomeFilterLower in warningBetHome ? (
                            <img
                              data-tooltip-content={
                                isEnableWarning
                                  ? warningBetHomeMessages[
                                      warningBetHome[
                                        nameCloneBetHomeFilterLower
                                      ]
                                    ]
                                  : undefined
                              }
                              data-tooltip-id={
                                isEnableWarning ? "tooltip-surebet" : undefined
                              }
                              className="style-icon-alert-filter"
                              src={
                                warningBetHomeIcons[
                                  warningBetHome[nameCloneBetHomeFilterLower]
                                ]
                              }
                            />
                          ) : (
                            ""
                          )}

                          <label
                            title=""
                            htmlFor={
                              "casasDeApostasClone" + value["name"] + indexClone
                            }
                            className="form-check-label"
                            name={nameCloneBetHomeFilterLower}
                          >
                            <span className="nameBetHomeLabelMobile">
                              {itemClone}
                            </span>

                            {newListBetHome.includes(
                              nameCloneBetHomeFilterLower,
                            ) === true ? (
                              <span
                                class="badge rounded-1 text-bg-warning ms-1 style-height-fit-content"
                                style={{ fontSize: "8px" }}
                              >
                                New
                              </span>
                            ) : (
                              ""
                            )}
                            {betHomeNoLimit.includes(
                              nameCloneBetHomeFilterLower,
                            ) && (
                              <>
                                <span class="badge rounded-1 style-bg-dark-green ms-1 style-height-fit-content">
                                  Não Limita
                                </span>
                              </>
                            )}

                            {listBettingHousesUnregulated.includes(
                              nameCloneBetHomeFilterLower,
                            ) && (
                              <>
                                <span class="badge rounded-1 style-bg-dark-green ms-1 style-height-fit-content">
                                  Não Regulamentada
                                </span>
                              </>
                            )}
                          </label>
                        </div>
                      );
                    })}
                </>
              ) : (
                ""
              )}
            </>
          );
        })}
        {filteredExchangeBetHome.length > 0 && (
          <h4 className="mode-h4">Exchange</h4>
        )}
        {filteredExchangeBetHome.map((value, index) => {
          let nameBetHomeFilterLower = value.toLowerCase();
          let isEnableWarning =
            nameBetHomeFilterLower in warningBetHome ? true : false;

          return (
            <React.Fragment key={index}>
              <div
                className={`ms-2 gap-2 form-check d-flex align-items-center ${
                  statusMode ? "textGray" : ""
                }`}
              >
                <input
                  type="checkbox"
                  id={"casasDeApostasExchange" + index}
                  className={`form-check-input ${
                    requiredBetHomeFrontEnd.includes(value.toLowerCase()) ===
                    true
                      ? "cus"
                      : ""
                  }`}
                  name={value.toLowerCase()}
                  checked={betHomeFrontEnd.includes(value.toLowerCase())}
                  onChange={EnabledDisablebBethome}
                />

                {nameBetHomeFilterLower in warningBetHome ? (
                  <img
                    data-tooltip-content={
                      isEnableWarning
                        ? warningBetHomeMessages[
                            warningBetHome[nameBetHomeFilterLower]
                          ]
                        : undefined
                    }
                    data-tooltip-id={
                      isEnableWarning ? "tooltip-surebet" : undefined
                    }
                    className="style-icon-alert-filter"
                    src={
                      warningBetHomeIcons[
                        warningBetHome[nameBetHomeFilterLower]
                      ]
                    }
                  />
                ) : (
                  ""
                )}

                <label
                  title=""
                  htmlFor={"casasDeApostasExchange" + index}
                  className="form-check-label"
                  name={value.toLowerCase()}
                >
                  <span className="nameBetHomeLabelMobile">{value}</span>
                  {newListBetHome.includes(nameBetHomeFilterLower) === true ? (
                    <span
                      class="badge rounded-1 text-bg-warning ms-1 style-height-fit-content"
                      style={{ fontSize: "8px" }}
                    >
                      New
                    </span>
                  ) : (
                    ""
                  )}

                  {betHomeNoLimit.includes(nameBetHomeFilterLower) && (
                    <>
                      <span class="badge rounded-1 style-bg-dark-green ms-1 style-height-fit-content">
                        Não Limita
                      </span>
                    </>
                  )}

                  {listBettingHousesUnregulated.includes(
                    nameBetHomeFilterLower,
                  ) && (
                    <>
                      <span class="badge rounded-1 style-bg-dark-green ms-1 style-height-fit-content">
                        Não Regulamentada
                      </span>
                    </>
                  )}
                </label>
              </div>
            </React.Fragment>
          );
        })}

        {filteredSportsbookBetHome.length > 0 && (
          <h4 className="mode-h4">Sportsbook</h4>
        )}
        {filteredSportsbookBetHome.map((value, index) => {
          let nameBetHomeFilterLower = value.toLowerCase();
          let isEnableWarning =
            nameBetHomeFilterLower in warningBetHome ? true : false;

          return (
            <React.Fragment key={index}>
              <div
                className={`ms-2 gap-2 form-check d-flex align-items-center ${
                  statusMode ? "textGray" : ""
                }`}
              >
                <input
                  type="checkbox"
                  id={"casasDeApostasSportsbook" + index}
                  className={`form-check-input ${
                    requiredBetHomeFrontEnd.includes(value.toLowerCase()) ===
                    true
                      ? "cus"
                      : ""
                  }`}
                  name={value.toLowerCase()}
                  checked={betHomeFrontEnd.includes(value.toLowerCase())}
                  onChange={EnabledDisablebBethome}
                />

                {nameBetHomeFilterLower in warningBetHome ? (
                  <img
                    data-tooltip-content={
                      isEnableWarning
                        ? warningBetHomeMessages[
                            warningBetHome[nameBetHomeFilterLower]
                          ]
                        : undefined
                    }
                    data-tooltip-id={
                      isEnableWarning ? "tooltip-surebet" : undefined
                    }
                    className="style-icon-alert-filter"
                    src={
                      warningBetHomeIcons[
                        warningBetHome[nameBetHomeFilterLower]
                      ]
                    }
                  />
                ) : (
                  ""
                )}

                <label
                  title=""
                  htmlFor={"casasDeApostasSportsbook" + index}
                  className="form-check-label"
                  name={value.toLowerCase()}
                >
                  <span className="nameBetHomeLabelMobile">{value}</span>
                  {newListBetHome.includes(nameBetHomeFilterLower) === true ? (
                    <span
                      class="badge rounded-1 text-bg-warning ms-1 style-height-fit-content"
                      style={{ fontSize: "8px" }}
                    >
                      New
                    </span>
                  ) : (
                    ""
                  )}
                  <br />
                  {betHomeNoLimit.includes(nameBetHomeFilterLower) && (
                    <>
                      <span class="badge rounded-1 style-bg-dark-green ms-1 style-height-fit-content">
                        Não Limita
                      </span>
                    </>
                  )}

                  {listBettingHousesUnregulated.includes(
                    nameBetHomeFilterLower,
                  ) && (
                    <>
                      <span class="badge rounded-1 style-bg-dark-green ms-1 style-height-fit-content">
                        Não Regulamentada
                      </span>
                    </>
                  )}
                </label>
              </div>
            </React.Fragment>
          );
        })}
        {!hasAnyBetHomeResult && searchTerm && (
          <div className="text-center py-3 px-2">
            <span className={statusMode ? "textGray" : "text-secondary"}>
              Nenhuma casa de apostas encontrada.
            </span>
          </div>
        )}
        <p></p>
      </div>
      <div
        className={`d-flex py-2 align-item-center border-top ps-4 fs-5 ${
          statusMode ? "bgDark borderColor textGray" : ""
        }`}
      >
        <Tooltip
          id="tooltip-surebet"
          data-tooltip-place="top"
          style={{ maxWidth: "100%" }}
        />
        <input
          type="checkbox"
          id="show_all_bet_home_mobile"
          className={"form-check-input"}
          checked={betHomeFrontEnd.length === quantityAllBetHome}
          onChange={markAll}
        />
        <label
          title=""
          htmlFor="show_all_bet_home_mobile"
          className="form-check-label ps-2"
        >
          Mostrar Tudo
        </label>
      </div>
      <div
        className={`d-flex justify-content-end align-item-center border-top ${
          statusMode ? "bgDark borderColor textGray" : ""
        }`}
      >
        <button
          className={`btn btn-primary m-2 fs-6 ${statusMode ? "" : ""}`}
          onClick={() => {
            openPageIndexFilter();
            saveFilterBetHome(betHomeFrontEnd);

            let newBetHomeFrontEnd = JSON.parse(
              JSON.stringify(betHomeFrontEnd),
            );
            newBetHomeFrontEnd = deduplicateArray(newBetHomeFrontEnd);

            let newrequiredBetHomeFrontEnd = JSON.parse(
              JSON.stringify(requiredBetHomeFrontEnd),
            );
            newrequiredBetHomeFrontEnd = deduplicateArray(
              newrequiredBetHomeFrontEnd,
            );

            if (accountFeatures.current.includes("global") === false) {
              newrequiredBetHomeFrontEnd = newrequiredBetHomeFrontEnd.filter(
                (item) => normalBetHomeLower.includes(item),
              );
            }

            saveFilterChanged({ actualBethomeEnable: newBetHomeFrontEnd });
            setRequiredBetHome(newrequiredBetHomeFrontEnd);
            localStorage.setItem(
              "riquiredsBethome",
              JSON.stringify(newrequiredBetHomeFrontEnd),
            );
          }}
        >
          Aplicar e Filtrar
        </button>
      </div>
    </>
  );
};

export default BetHome;
